import React from 'react';
import { Datagrid } from 'react-admin';
import { withStyles } from '@material-ui/core';

const styles = {
  headerCell: {
    padding: '16px 24px',
    fontSize: '16px',
    color: '#252525 !important',
    borderBottom: '1px solid #EDEDED',
  },
  rowCell: {
    padding: '16px 24px',
    color: '#212322',
    fontSize: '16px',
    borderBottom: '1px solid #EDEDED',
    '& a':{
      color: 'inherit',
      textDecoration: 'none'
    },
    '& span':{
      color: 'inherit',
      fontSize: 'inherit'
    }
  },
};

const StyledDatagrid = props => (
  <Datagrid {...props}/>
)

export default withStyles(styles)(StyledDatagrid)
